import { colors } from "@teamrota/rota-design";
import styled from "styled-components";
import { STYLE_CONSTS } from "~/src/styles/config.style";

export const StyledOpenShiftContainer = styled.div`
  width: 20%;
  min-width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;

  animation: fade-in 0.2s ease-out forwards;

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const GridCardWrapper = styled.div`
  width: 95%;
  white-space: nowrap;
  height: 50px;
  background: ${({ isCancelled, isDraft, isNightShift }) =>
    isCancelled
      ? "repeating-linear-gradient(-60deg,transparent 0px 10px,#ffeaea 10px 20px)"
      : isDraft
      ? "white"
      : isNightShift
      ? "#313131"
      : colors.lightOrange};
  border: ${({ isDraft }) => (isDraft ? "2px dashed" : "2px solid")};
  border-color: ${({ isCancelled }) => (isCancelled ? "#ff0000" : "#ff9300")};
  border-radius: 5px;
  padding: ${({ padding }) => padding || "5px"};
  line-height: ${({ lineHeight }) => lineHeight};
  overflow: hidden;
  margin: ${({ margin }) => margin || "0 1px"};
  cursor: pointer;
  color: ${({ isNightShift, isDraft, isCancelled }) =>
    isNightShift && !isDraft && !isCancelled ? "white" : "black"};
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
  pointer-events: ${({ isLoading }) => (isLoading ? "none" : "all")};
  cursor: ${({ isLoading }) => (isLoading ? "not-allowed" : "pointer")};
`;

export const Div = styled.div`
  display: flex;
  width: ${({ width }) => width};
  justify-content: center;
  align-items: center;
  line-height: ${({ lineHeight }) => lineHeight};
  font-size: ${({ fontSize }) => fontSize || STYLE_CONSTS.FONT_SMALL};
  font-weight: ${({ fontWeight }) => fontWeight || STYLE_CONSTS.FONT_WEIGHT};
  text-transform: ${({ textTransform }) => textTransform};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  text-overflow: ellipsis;
  white-space: ${({ wrap }) => wrap || "nowrap"};
`;
